export default {
  "giphyWrapper": "_8FxqA",
  "giphy_player": "_-1w37",
  "playIcon": "c81ju",
  "gifRatio": "NpVnz"
};